import React, { FC } from "react";
import Avatar from "@components/Avatar/Avatar";
import styled from "@emotion/styled";
import StateIcon from "@components/StateIcon/StateIcon";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
import Subtitles from "@components/Subtitles";
import { useCompanionConversation } from "@components/Companion/CompanionConversationContext";

const AvatarContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const State = styled.div`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
`;

const SubtitlesContainer = styled.div`
  position: absolute;
  bottom: 64px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  max-height: 50dvh;
`;

const BasicCompanion: FC<{ sessionId: string; companionName: string }> = ({
  sessionId,
  companionName,
}) => {
  const { text, subtitlesOn } = useSelector((state: RootState) => state.avatar);
  const { conversationPacing, voiceInputMode, pauseDurationMs, ttsEvictionMs } =
    useCompanionConversation();

  return (
    <AvatarContainer>
      <Avatar
        sessionId={sessionId}
        companionName={companionName}
        conversationPacing={conversationPacing}
        voiceInputMode={voiceInputMode}
        pauseDurationMs={pauseDurationMs}
        ttsEvictionMs={ttsEvictionMs}
      />

      {subtitlesOn && text && (
        <SubtitlesContainer>
          <Subtitles text={text} />
        </SubtitlesContainer>
      )}

      <State>
        <StateIcon />
      </State>
    </AvatarContainer>
  );
};

export default BasicCompanion;
